import {
  AnyHash,
  FieldConfig,
  FieldDataTypes,
  nNumber,
  nString,
  uNumber,
} from '@hidat/huijs-common';
import { SplixerResourceInterface } from './splixer-resource.interface';
import { ResourceConfig } from '@hidat/huijs-resource';
import { splixerSystemFields } from './splixer-fields.const';
import { ZonedDateTime } from '@js-joda/core';

export const RawShowConfig = new ResourceConfig(
  'RawShow',
  'raw_shows',
  false,
  true,
)
  .addFields(splixerSystemFields)
  .addFields([
    new FieldConfig('rawProgramId', FieldDataTypes.INTEGER),
    new FieldConfig('rawHostId', FieldDataTypes.INTEGER),
    new FieldConfig('remoteId', FieldDataTypes.INTEGER),
    new FieldConfig('remoteCode'),
    new FieldConfig('startedAt', FieldDataTypes.DATETIME),
    new FieldConfig('endedAt', FieldDataTypes.DATETIME),
    new FieldConfig('content', FieldDataTypes.HASH).setEditable(false),
  ])
  .setSorts({
    startedat: 'startedAt',
  })
  .setDefaultSort('startedat');

export interface RawShowInterface extends SplixerResourceInterface<number> {
  stationId: uNumber;
  channelId: uNumber;
  startedAt: ZonedDateTime | undefined;
  endedAt: ZonedDateTime | undefined;
  content: AnyHash | undefined;
  rawProgramId: nNumber;
  rawHostId: nNumber;
  remoteId: nNumber;
  remoteCode: nString;
}
